import { useContext } from "react";

import { FileContext } from "Contexts/File";

const UseFile = () => {
  const { getFileExtension, uploadFile } = useContext(FileContext);

  return {
    getFileExtension,
    uploadFile,
  };
};

export default UseFile;
